// // Action names should be imported from their respective action modules
import {
    BLOB_BEGIN,
    BLOB_SUCCESS,
    BLOB_FAILURE
} from '../actions/BlobActions';

// Example initial state
const initialState = {
    item: {},
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function BlobReducer(state = initialState, action) {
    switch (action.type) {
        case BLOB_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case BLOB_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case BLOB_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        default:
            return state;
    }
};


export const blobError = state => {
    return state.error;
}

export const blobIsLoading = state => {
    return state.isLoading;
}

export const blob = state => {
    return state.item;
}